import { combineReducers } from "redux";
import { LOGOUT } from "../types";
import loadingReducer from "./loadingReducer";
import usersReducer from "./usersReducer";
import authReducer from "./authReducer";
import sidebarReducer from "./sidebarReducer";
import modalReducer from "./modalReducer";

const appReducer = combineReducers({
    auth: authReducer,
    loading: loadingReducer,
    users: usersReducer,
    sidebar: sidebarReducer,
    modal: modalReducer,
});

const rootReducer = (state, action) => {
    if (action.type === LOGOUT) {
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
